import { render, staticRenderFns } from "./LayoutColumnContent.vue?vue&type=template&id=748ae7a8&"
import script from "./LayoutColumnContent.vue?vue&type=script&lang=js&"
export * from "./LayoutColumnContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('748ae7a8')) {
      api.createRecord('748ae7a8', component.options)
    } else {
      api.reload('748ae7a8', component.options)
    }
    module.hot.accept("./LayoutColumnContent.vue?vue&type=template&id=748ae7a8&", function () {
      api.rerender('748ae7a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/layout/LayoutColumnContent.vue"
export default component.exports